module.exports = __webpack_public_path__ + "img/card-mastercard.a5b49ac5.svg";